<div fxLayout="row wrap" fxLayoutGap="15px" class="messaging-provider-template">
  <div fxFlex="45">
    <mat-form-field>
      <mat-select
        placeholder="Select {{ channelType }} Provider"
        [(ngModel)]="selectedProvider"
        [disabled]="disabled"
        (selectionChange)="onProviderChange($event.value)"
      >
        <mat-option *ngFor="let p of providerOptions" [value]="p.value">{{ p.label }}</mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <div fxFlex="45" *ngIf="showTemplatePicker">
    <mat-form-field>
      <mat-select
        placeholder="Select Template"
        [(ngModel)]="selectedTemplateId"
        [disabled]="disabled || loadingTemplates"
        (selectionChange)="onTemplateChange($event.value)"
      >
        <mat-option *ngFor="let t of templateOptions" [value]="t.value">{{ t.label }}</mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <div fxFlex="10" *ngIf="showTemplatePicker && selectedTemplateId && false">
    <button mat-stroked-button type="button" color="primary" (click)="previewTemplate()">Preview</button>
    <button mat-icon-button type="button" title="Edit template" (click)="editSelectedTemplate()">
      <mat-icon>edit</mat-icon>
    </button>
    <button mat-icon-button type="button" title="Delete template" (click)="deleteSelectedTemplate()">
      <mat-icon>delete</mat-icon>
    </button>
  </div>
</div>
